import React from 'react';
import './GameBoard.css';
import WordDisplay from './WordDisplay';
import GameStats from './GameStats';
import GuessedLetters from './GuessedLetters';
import GuessForm from './GuessForm';
import { GameState, UserSettings } from '../types/GameTypes';

interface GameBoardProps {
  gameState: GameState;
  settings: UserSettings;
  onGuessLetter: (letter: string) => void;
  dailyChallengeCompleted: boolean;
  gameMode: 'daily' | 'free-play';
}

const GameBoard: React.FC<GameBoardProps> = ({
  gameState,
  settings,
  onGuessLetter,
  dailyChallengeCompleted,
  gameMode
}) => {
  return (
    <div className="game-board">
      <WordDisplay 
        secretWord={gameState.secretWord}
        revealedIndices={gameState.revealedIndices}
        gameWon={gameState.gameWon}
        gameLost={gameState.gameLost}
      />
      
      <GameStats 
        revealedCount={gameState.revealedIndices.length}
        totalLetters={gameState.secretWord.length}
        score={gameState.score}
        gameOver={gameState.gameOver}
        letterGuessesLeft={gameState.letterGuessesLeft}
        maxLetterGuesses={6}
      />
      
      <GuessedLetters
        guessedLetters={gameState.guessedLetters}
        secretWord={gameState.secretWord}
        autoRevealedLetters={gameState.autoRevealedLetters}
        visible={settings.showGuessedLetters}
      />
      
      <GuessForm 
        onGuessLetter={onGuessLetter}
        gameOver={gameState.gameOver}
        wordLength={gameState.secretWord.length}
        secretWord={gameState.secretWord}
        letterGuessesLeft={gameState.letterGuessesLeft}
        guessedLetters={gameState.guessedLetters}
        autoRevealedLetters={gameState.autoRevealedLetters}
        dailyChallengeCompleted={dailyChallengeCompleted}
      />
    </div>
  );
};

export default GameBoard;
